var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgId(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "37px",
    viewBox: "0 0 57 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sb-d-Step-5",
    transform: "translate(-1034.000000, -278.000000)",
    stroke: "#FB9A02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(1035.000000, 279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-verification",
    transform: "translate(-1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 55,
    height: 35,
    rx: 5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "check-2",
    strokeWidth: 2,
    points: "31 18 35 22 42 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,26 L8,26 C8,22.686 10.686,20 14,20 L16,20 C19.314,20 22,22.686 22,26 Z",
    id: "Stroke-1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,12.9999998 C19,14.4290617 18.237604,15.7495696 17,16.4641015 C15.762396,17.1786325 14.237604,17.1786325 13,16.4641015 C11.762396,15.7495696 11,14.4290617 11,12.9999998 C11,11.5709378 11.762396,10.2504299 13,9.53589797 C14.237604,8.82136701 15.762396,8.82136701 17,9.53589797 C18.237604,10.2504299 19,11.5709378 19,12.9999998 Z",
    id: "Stroke-3",
    strokeWidth: 2
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.34bbbe3949e4ab917434741d06e57166.svg";
export { ForwardRef as ReactComponent };